import { render, staticRenderFns } from "./c-receive-list.vue?vue&type=template&id=ca84670a"
import script from "./c-receive-list.vue?vue&type=script&lang=js"
export * from "./c-receive-list.vue?vue&type=script&lang=js"
import style0 from "./c-receive-list.vue?vue&type=style&index=0&id=ca84670a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports